import { render, staticRenderFns } from "./right-bottom.vue?vue&type=template&id=4a317aea&scoped=true&"
import script from "./right-bottom.vue?vue&type=script&lang=js&"
export * from "./right-bottom.vue?vue&type=script&lang=js&"
import style0 from "./right-bottom.vue?vue&type=style&index=0&id=4a317aea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a317aea",
  null
  
)

export default component.exports